import { render, staticRenderFns } from "./TB.vue?vue&type=template&id=fb9aacc6&"
import script from "./TB.vue?vue&type=script&lang=js&"
export * from "./TB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports